/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum WarrantySortField {
  WarrantyType = 0,
  WarrantyNumber = 1,
  TotalValue = 2,
  CurrencyCode = 3,
  ValueUsed = 4,
  CustomsOffice = 5,
  TIN = 6,
  MainAccountable = 7,
  Adress = 8,
  PostCode = 9,
  City = 10,
  CountryCode = 11,
  AccessKey = 12,
}
